import { TerminalMapData } from 'ais-facade-api/api';
import { useGetTerminalsOnMapMutation } from 'app/api/facade';
import { svgToDataURL } from 'app/helpers';
import { getTerminalIcon } from 'helpers/getWebGLPointIcon';
import { useAppDispatch, useAppSelector } from 'app/store/store';
import { setTerminalsOnMap } from 'app/utils/facadeReducer';
import { setHoveredTarget } from 'app/utils/mapStateSlice';
import { setSelectedTarget } from 'app/utils/selectedTargetsSlice';
import { IconLayer } from 'deck.gl/typed';
import { useEffect } from 'react';

export const useLayerTerminals = (viewState: any, showTerminals: boolean) => {
  const mode = useAppSelector((state) => state.mapStateSlice.mode);
  const isAnalyticsMode = mode === 'analytics';
  const terminals = useAppSelector((state) => state.facadeSlice.terminalsOnMap);

  const [, { data: terminalsResponce, ...terminalsRequest }] = useGetTerminalsOnMapMutation({
    fixedCacheKey: 'get-terminals-mutation',
  });
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (terminalsResponce?.results && terminalsRequest.isSuccess) {
      dispatch(setTerminalsOnMap(terminalsResponce?.results));
    }
  }, [terminalsRequest]);

  const layerTerminals = new IconLayer({
    id: 'layer-terminals',
    data: terminals,
    pickable: true,
    getPosition: (d: TerminalMapData): [number, number, number] => {
      if (typeof d?.lon === 'number' && typeof d?.lat === 'number') return [d.lon, d.lat, 0];
      return [999, 999, 10];
    },
    getAngle: (d) => {
      return -d.heading || -d.cog;
    },
    getIcon: () => ({
      url: svgToDataURL(getTerminalIcon()),
      width: 32,
      height: 32,
    }),
    onClick(pickingInfo) {
      dispatch(setSelectedTarget({ target: pickingInfo, type: 'terminal' }));
    },
    onHover(pickingInfo) {
      dispatch(setHoveredTarget(pickingInfo));
    },

    sizeMinPixels: 32,
    autoHighlight: true,
    visible: viewState.zoom > 8 && showTerminals && !isAnalyticsMode,
  });
  return layerTerminals;
};
